export const SECURITY_TABS = ['overview', 'events', 'auth', 'blocked', 'alerts'] as const;
export type SecurityTab = (typeof SECURITY_TABS)[number];

export function isSecurityTab(value: string | null): value is SecurityTab {
  return Boolean(value) && (SECURITY_TABS as readonly string[]).includes(value as string);
}
